import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';

import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import DDPDetailsAccordion from '../../../components/DetailsAccordion/DDPDetailsAccordion';

import DDPChart from './DDPChart';
import OnTimeDeliveryWidget from './OnTimeDeliveryWidget';

import '../DueDatePerformance.scss';

class WallboardDDPChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Due Date Performance Char</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="ddp" showLineChart />
            <DatePicker />
          </div>
        </div>
        <div>
          <div className="dashboard_details">
            {this.props.lineChart && this.props.ontimeData && !!this.props.ontimeData.length && (
              <OnTimeDeliveryWidget id="ontime_delivery" data={this.props.ontimeData} />
            )}
            <DDPDetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
          </div>
          <div className="diagram_details">
            <DDPChart id="DDP" data={this.props.data} onPointClick={this.handlePointClick} />
            <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lineChart: state.filters.ddp.lineChart,
    data: state.ddp.data,
    ontimeData: state.ddp.ontimeData,
    isLoading: state.ddp.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardDDPChart);
